import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AiFillLinkedin, AiFillMail } from "react-icons/ai";
import "./contact.css";

const Contact = () => {
  return (
    <Container className="footer pt-5" id="contacts">
      <Row>
        <Col>
          <div className="d-flex align-items-center">
            <img
              alt="footer-logo"
              className="footer__image"
              src="/assets/images/icon2.png"
            />
            <h1 className="ms-5">Pdf-Toolkit</h1>
          </div>
        </Col>
        <Col className="footer__contact text-end">
          <h1 className="footer__contact-title mb-3">Contact</h1>
          <a
            className="footer__icon me-5"
            target="_blank"
            rel="noreferrer"
            href="https://www.linkedin.com/in/pramod-jacob-sam-48581620a/"
          >
            <AiFillLinkedin size={40} />
          </a>
          <a
            href="mailto:pramodjsam@gmail.com"
            className="footer__icon icon-gmail"
          >
            <AiFillMail size={40} color="#e5322d" />
          </a>
        </Col>
      </Row>
      <div className="text-center mt-5 fs-4">
        Copyright © by{" "}
        <span className="text-danger fs-3">Pramod Jacob Sam</span>.You are 100%
        allowed to use this application for both personal and commercial use,
        but NOT to claim it as your own product. A credit to the original
        author, Pramod Jacob Sam, is of course highly appreciated!
      </div>
    </Container>
  );
};

export default Contact;
